export default __webpack_public_path__ + "static/media/login.bd9a831d.png";